import { render, staticRenderFns } from "./goodsShareTemp.vue?vue&type=template&id=05d1919f&scoped=true&"
import script from "./goodsShareTemp.vue?vue&type=script&lang=js&"
export * from "./goodsShareTemp.vue?vue&type=script&lang=js&"
import style0 from "./goodsShareTemp.vue?vue&type=style&index=0&id=05d1919f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d1919f",
  null
  
)

component.options.__file = "goodsShareTemp.vue"
export default component.exports